import { RoleBadge } from "@/components/RoleBadge";

export function BrandHeader({ role, subtitle }) {
  return (
    <div className="px-6 pt-6 pb-4">
      <div className="flex items-baseline gap-2.5">
        <h1 className="font-heading text-lg font-semibold tracking-tight text-[#111111]">QuickInbox</h1>
        <RoleBadge role={role} />
      </div>
      {subtitle && (
        <p className="text-[10px] tracking-widest uppercase text-[#888888] mt-0.5">{subtitle}</p>
      )}
    </div>
  );
}
